/* arrow.icon.svg.js */

"use strict";
module.exports = {
    icon: `
            <svg viewBox="-301 385.3 24 24" preserveAspectRatio="none">
                <path class="foreground-gl" d="M-299.3,389.7h1.2c0.9,0,1.7-0.8,1.7-1.7v-1.4c0-0.9,0.6-1.4,1.4-0.8l17.6,10.5c0.8,0.5,0.8,1.2,0,1.7l-17.4,10.7
                    c-0.8,0.5-1.4,0.2-1.5-0.8v-1.4c0-0.9-0.8-1.7-1.7-1.7h-1.2c-0.9,0-1.7-0.8-1.7-1.7v-12C-301,390.4-300.2,389.7-299.3,389.7z"/>
            </svg>
        `,
};
